module.exports = __webpack_public_path__ + "img/logo-features.7b0dceec.png";